import { useLocation, useNavigate } from "react-router-dom";
import MobileApp from "./MobileApp";
import fr from "@/content/fr";

// Même logique que Navbar : sur l'accueil on défile, ailleurs on revient à l'accueil puis on défile.
export default function MobileNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const va = (id) => () => {
    if (pathname !== "/") return navigate("/", { state: { scrollTo: id } });
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const surEvenement = pathname.startsWith("/expo-") || pathname.startsWith("/beauty-");
  const tabs = [
    { id: "hero", label: fr.nav.home, icon: "home", onClick: () => (pathname === "/" ? scrollTo({ top: 0, behavior: "smooth" }) : navigate("/")), active: (p) => p === "/" },
    { id: "events", label: fr.nav.events, icon: "cal", sheet: "events", active: () => surEvenement },
    { id: "editions", label: fr.nav.editions, icon: "layers", onClick: va("editions") },
    { id: "partners", label: fr.nav.partners, icon: "hand", onClick: va("partners") },
    { id: "contact", label: "Contact", icon: "chat", sheet: "contact" },
  ];
  const sheets = {
    events: {
      title: fr.nav.events,
      items: [
        { label: fr.nav.streetwearTab, icon: "cal", to: "/expo-streetwear-sneaker-culture" },
        { label: fr.nav.beautyTab, icon: "cal", to: "/beauty-wellness-weekend" },
      ],
    },
    contact: {
      title: "Contact",
      items: [
        { label: "E-mail", sub: fr.footer.contact, icon: "mail", href: `mailto:${fr.footer.contact}` },
        { label: fr.nav.cta, icon: "hand", onClick: va("partners"), primary: true },
      ],
    },
  };
  const theme = { "--ma-bar": "rgba(21,4,46,.88)", "--ma-bord": "rgba(255,255,255,.12)", "--ma-on-bg": "#E91E63", "--ma-on": "#fff", "--ma-off": "rgba(255,255,255,.62)", "--ma-sheet": "#1F0A48", "--ma-accent": "#E91E63", "--ma-accent-txt": "#fff" };
  return <MobileApp tabs={tabs} sheets={sheets} label="Navigation mobile" theme={theme} />;
}
